import React from "react";  

import {  
    DashboardAnimation,
    DashboardTitle,
    DashboardText,
    ContentFilterAction,
    ContentTableAction,
    ContentTableActionIcon
} from "./styled";

import ContainerAuthenticated from "containers/Authenticated";
import { Row, Col } from "reactstrap";
import BasicTable from "components/Form/Table";
import Button from "components/Form/Button";

export default function DashboardRelatedReportApplications(){  


    const columns = [
        { title:'Trimestre', ref:'quarter' },
        { title:'Amortização', ref:'amortization' },
        { title:'Aplicação', ref:'application' },
        { title:'Acumulação', ref:'accumulation' },
    ]
    
    const rows = [
        { quarter:'1TR-2018', amortization:'188.307.865', application:'170.174.000', accumulation:'176.020.618' },
        { quarter:'2TR-2018', amortization:'188.307.865', application:'170.174.000', accumulation:'176.020.618' },
        { quarter:'3TR-2018', amortization:'188.307.865', application:'170.174.000', accumulation:'176.020.618' },
        { quarter:'4TR-2018', amortization:'188.307.865', application:'170.174.000', accumulation:'176.020.618' },
        { quarter:'1TR-2019', amortization:'188.307.865', application:'170.174.000', accumulation:'176.020.618' },
        { quarter:'2TR-2019', amortization:'188.307.865', application:'170.174.000', accumulation:'176.020.618' },
        { quarter:'3TR-2019', amortization:'188.307.865', application:'170.174.000', accumulation:'176.020.618' },
        { quarter:'4TR-2019', amortization:'188.307.865', application:'170.174.000', accumulation:'176.020.618' },
        { quarter:'1TR-2020', amortization:'188.307.865', application:'170.174.000', accumulation:'176.020.618' },
        { quarter:'2TR-2020', amortization:'188.307.865', application:'170.174.000', accumulation:'176.020.618' },
        { quarter:'3TR-2020', amortization:'188.307.865', application:'170.174.000', accumulation:'176.020.618' },
        { quarter:'4TR-2020', amortization:'188.307.865', application:'170.174.000', accumulation:'176.020.618' },
    ]

    return ( 
        <>
            <ContainerAuthenticated page={"relatedreport/applications"}> 
                <Row>
                    <Col sm={12} >
                        <DashboardTitle>
                            Aplicações e Amortizações
                        </DashboardTitle> 

                        <ContentFilterAction> 
                            <ContentTableAction>
                                <Button primary nospace small onClick={() => null }>
                                    Exportar
                                    <ContentTableActionIcon />
                                </Button>
                            </ContentTableAction>
                        </ContentFilterAction>


                        {/* 
                            <DashboardText>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur ut congue nisl. Duis lobortis ante vitae hendrerit efficitur. Quisque dolor magna, efficitur et nunc id, pretium porta mauris. Integer vel lobortis risus. Duis consectetur ac ante at ullamcorper. Nullam luctus sollicitudin odio, eu gravida lorem efficitur ac. Nam pulvinar consequat cursus. Maecenas convallis sagittis erat, at tristique lectus pharetra et. In eget metus nisl. Maecenas orci ipsum, sagittis non erat eleifend, dignissim suscipit mi. Ut a tellus quis enim pellentesque fringilla. Sed in malesuada felis, eget volutpat neque.
                            </DashboardText>  
                        */}

                        <BasicTable columns={columns} rows={rows} />


                    </Col>
                    <Col></Col>
                </Row>
            </ContainerAuthenticated> 
        </>
    );
}